var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3712 1.89051L13.2221 0.0487981C13.0813 -0.016266 12.9188 -0.016266 12.778 0.0487981L8.62891 1.89051L12.9999 3.7429L17.3712 1.89051Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8754 7.28005V2.84912L13.542 4.69083V9.5604L17.5558 7.77829C17.7507 7.69169 17.8754 7.4965 17.8754 7.28L17.8754 7.28005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 2.84912V7.28005C8.125 7.49678 8.24969 7.69175 8.44465 7.77834L12.4584 9.56045V4.69089L8.125 2.84912Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5701 15.9035L20.5839 17.6856V12.816L16.2504 10.8823V12.4585H13.542V9.56055L13.2224 9.70133C13.1519 9.73375 13.0762 9.75007 13.0002 9.75007C12.9243 9.75007 12.8485 9.73375 12.778 9.70133L12.4588 9.56055V12.4585H9.75042V10.9364L5.41699 12.816V17.6856L9.43076 15.9035C9.62572 15.8169 9.75041 15.6219 9.75041 15.4052V13.5419H12.4588V16.4399L8.63455 18.1354L13.0004 19.993L17.3121 18.1134L13.542 16.4397V13.5417H16.2504V15.4049C16.2504 15.6217 16.3751 15.8169 16.5701 15.9035L16.5701 15.9035Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 15.4049V10.9849L21.667 12.8157V17.6853L25.6808 15.9032C25.8757 15.8166 26.0004 15.6214 26.0004 15.4049L26.0004 15.4049Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5072 10.021L21.3472 8.1738C21.2064 8.10873 21.0438 8.10873 20.9031 8.1738L16.8623 9.96682L21.125 11.868L25.5072 10.021Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0976 8.1738C4.95682 8.10873 4.79427 8.10873 4.65349 8.1738L0.541992 9.9992L4.87542 11.8679L9.19794 9.99375L5.0976 8.1738Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.319662 15.9035L4.33343 17.6856V12.816L0 10.9419V15.4052C0 15.6217 0.124684 15.8169 0.31965 15.9035L0.319662 15.9035Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12501 23.53C8.12501 23.7467 8.2497 23.9417 8.44466 24.0283L12.4584 25.8104V20.9408L8.125 19.0991L8.12501 23.53Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.541 25.8104L17.5548 24.0283C17.7498 23.9417 17.8744 23.7467 17.8744 23.53V19.0503L13.541 20.9408L13.541 25.8104Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterDropdown);
export default __webpack_public_path__ + "static/media/FooterDropdown.35d05af8aaf00a5ab1944f65afeda351.svg";
export { ForwardRef as ReactComponent };